const URL = {
  CREATE_CERTIFICATE: 'certificate/{collectionId}/create',
  GET_CERTIFICATE: 'certificate/{collectionId}/get',
  PATCH_CERTIFICATE: 'certificate/{certificateId}/patch',
  GET_CERTIFICATE_LIST: 'certificate/list?collectionId={collectionId}',
  GET_CERTIFICATE_PAYMENT_SETTING: 'certificate/{collectionId}/payment-setting',
  PATCH_CERTIFICATE_PAYMENT_SETTING: 'certificate/{collectionId}/payment-setting',
  SET_CERTIFICATE_PRICE: 'certificate/{collectionId}/payment-setting/price',
  DELETE_CERTIFICATE_PRICE: 'certificate/{collectionId}/payment-setting/price',
}

export default URL
